module.exports = __webpack_public_path__ + "static/img/Elizabeth.Lukin.2059860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elizabeth.Lukin.jpg
// module id = ZGAT
// module chunks = 0